<template>
	<VueHtml2pdf
		ref="html2Pdf"
		:show-layout="false"
		:float-layout="true"
		:enable-download="false"
		:preview-modal="true"
		:paginate-elements-by-height="1400"
		:filename="filename"
		:pdf-quality="2"
		:manual-pagination="false"
		:html-to-pdf-options="options"
		@beforeDownload="beforeDownload($event)"
	>
		<template slot="pdf-content">
			<v-app>
				<div class="mx-8 mt-8">
					<v-avatar size="48px">
						<img :src="logo"></img>
					</v-avatar>
					<span class="ml-4 text-h4">{{ logoTitle }}</span>

					<h2 class="text-center">{{ title }}</h2>

					<v-row no-gutters>
						<v-col cols="12" class="text-right">
							{{ currentdate | formatDateTime }}
						</v-col>
					</v-row>
				</div>

				<v-divider class="mx-8"></v-divider>

				<div class="mx-8 my-6" v-if="parameters.length">
					<div class="text-subtitle-1 font-weight-bold">Параметри</div>
					<v-simple-table dense>
						<template v-slot:default>
							<tbody>
								<tr v-for="(item, index) in parameters" :key="index">
									<td width="50%">{{ item.name }}</td>
									<td>{{ item.value }}</td>
								</tr>
							</tbody>
						</template>
					</v-simple-table>
				</div>

				<div class="mx-8 my-6" v-if="equipments.length">
					<v-divider></v-divider>
					<v-simple-table dense>
						<template v-slot:default>
							<thead>
								<tr>
									<th class="text-left">Код</th>
									<th class="text-left">Назва</th>
									<th class="text-left">Значення</th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="(equipment, index) in equipments" :key="index">
									<td>{{ equipment.VariableId }}</td>
									<td>{{ equipment.Variable }}</td>
									<td>{{ equipment.Value }}</td>
									<!-- <td>{{ equipment.ValueId }}</td> -->
								</tr>
							</tbody>
						</template>
					</v-simple-table>
				</div>
			</v-app>
		</template>
	</VueHtml2pdf>
</template>

<script>
import mixin from './mixin/main'
import VueHtml2pdf from 'vue-html2pdf' //https://www.npmjs.com/package/vue-html2pdf

export default {
	mixins: [mixin],
	components: { VueHtml2pdf },

	computed: {
		equipments() {
			return this.data?.Results ? this.data.Results : [];
		},
	},
}

</script>